import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Cache } from 'aws-amplify';
import { Row, Col, Button, Table, Form } from 'react-bootstrap';
import { fetchClients, 
  filterClients, 
  SET_CLIENTS_PAGINATION, 
  RESET_CLIENTS_PAGINATION } from '../../../store/actions/clients/clientsActions';
import { PORTAL_ADMIN, PROJECT_ADMIN } from '../../../store/actions/users/usersActions';
import { resetPagination } from '../../../store/actions/commonActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import PageTitle from '../../../common/PageTitle';
import ListPagination from '../../../common/ListPagination';

class Clients extends Component {

  componentDidMount() {
    const roleId = Cache.getItem('roleId');
    if (roleId === PORTAL_ADMIN || roleId === PROJECT_ADMIN) {
      this.props.fetchClients();
      this.props.resetPagination(RESET_CLIENTS_PAGINATION);
    }
    else {
      this.props.history.push('/dashboard');
    }
  }

  filterClients = () => {
    return (
      <Form.Control size="xl" type="search" placeholder="Filter Clients" onChange={(e) => {
        const filter = e.target.value;
        this.props.filterClients(filter);
      }} />
    )
  }

  getFilteredClients = (clients) => {
    if (!clients) {
      return null;
    }

    return clients.filter(client => {
      const clientName = client.client_name || '';
      const clientCode = client.client_code || '';

      const clientdata = [
        clientName,
        clientCode,
      ].join(" ").toLowerCase();
      
      const clientFilter = this.props.clients.clientFilter; 

      if (!clientFilter || clientdata.includes(clientFilter.toLowerCase())) {
        return client;
      }
      return null;
    })
  }

  renderClients = () => {
    let clients = this.getFilteredClients(this.props.clients.clients);
    
    if (clients) {
      //if the user tries to search and no matches the filter
      if (this.props.clients.clientFilter && !clients.length) {
        clients = null;
      }
      else {
        let min = this.props.clients.min;
        let max = this.props.clients.max;
        
        if (!this.props.clients.clientFilter) {
          clients = clients.slice(min - 1, max);
        }
      }
    } 
   
    let clientList = [];

    if (clients) {
      clientList = clients.length ? (
        clients.map((client, key) => {
          return (
            <tr key={key}>
              <td>{client.client_name}</td>
              <td className="align-center">{client.client_code}</td>
              <td className="align-right">
                <Button size="sm" className="btn-primary" onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push('/settings/clients/update?code=' + client.client_code)
                }}>
                  <FontAwesomeIcon icon={faPen} /> Edit 
                </Button>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td>Loading....</td>
        </tr>
      )
    }
    else {
      return (
        <tr>
          <td colSpan={3}>No results found.</td>
        </tr>
      )
    }

    return clientList;
  }

  render() {
    const addClient = <Button id="add-client" size="sm" onClick={() => {
      this.props.history.push('/settings/clients/add')
    }}>Add Client</Button>

    let listPagination = '';

    if (!this.props.clients.clientFilter) {
      listPagination = (
        <div className="float-right mt-3">
          <ListPagination 
            dispatchType={SET_CLIENTS_PAGINATION}
            data={this.props.clients.clients} 
            min={this.props.clients.min}
            max={this.props.clients.max}
            currentPage={this.props.clients.currentPage} 
            totalPages={this.props.clients.totalPages} 
            fetchCallback="" 
            numItems={this.props.clients.numItems} />
        </div>
      )
    }
    return (
      <>
        <PageTitle pageName="Clients" actionButton={addClient} />
        <Row>
          <Col>
            {listPagination}
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table>
              <thead>
                <tr>
                  <th className="align-center">Client Name</th>
                  <th className="align-center">Client Code</th>
                  <th className="align-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={3}>
                    { this.filterClients() }
                  </td>
                </tr>
                { this.renderClients() }
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>
            {listPagination}
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToDispatch = (state) => ({
  clients: state.clients 
})

const mapDispatchToProps = (dispatch) => ({
  fetchClients: () => dispatch(fetchClients()),
  resetPagination: (...args) => dispatch(resetPagination(...args)),
  filterClients: (...args) => dispatch(filterClients(...args))
})

export default withRouter(connect(mapStateToDispatch, mapDispatchToProps)(Clients))
